import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass([
      'w-min relative',
      'flex justify-center items-center',
      'bg-base-100 rounded-lg border border-base-content/20 focus-within:border-base-content/50',
    ])
}
const _hoisted_2 = { class: "p-2" }

import { computed, ref, watch } from "vue";
import { colord } from "colord";
import { RGB8 } from "@/keyboard";
import ColorDot from "@/components/utils/ColorDot.vue";
import ColorPicker from "@/components/utils/ColorPicker.vue";
import PopupButton from "@/components/utils/PopupButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ColorInput',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const fromRgb8 = (c: RGB8) => ({ r: c[0], g: c[1], b: c[2] });
const toRgb8 = (c: {
  r: number;
  g: number;
  b: number;
}): [number, number, number] => [c.r, c.g, c.b];

const hexColor = computed(() => colord(fromRgb8(props.modelValue)).toHex());
const inputColor = ref(hexColor.value);

watch(hexColor, () => (inputColor.value = hexColor.value));

watch(inputColor, (text) => {
  const color = colord(text);
  if (!color.isValid()) return;
  emit("update:modelValue", toRgb8(color.toRgb()));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      class: "color-text input border-transparent font-mono text-center w-[12ch]",
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputColor).value = $event))
    }, null, 512), [
      [_vModelText, inputColor.value]
    ]),
    _createVNode(PopupButton, {
      placement: "right",
      offset: -2,
      renderOnShow: true
    }, {
      button: _withCtx(() => [
        _createVNode(ColorDot, { color: hexColor.value }, null, 8, ["color"])
      ]),
      popup: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ColorPicker, {
            modelValue: _ctx.modelValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => _ctx.$emit('update:modelValue', v))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})